export const CUSTOM_ORDER_SOURCE = 'from_gig_page';
